import React, { ReactElement } from "react";

interface IHeader {
    children: React.ReactNode;
}

const Header = ({ children }: IHeader): ReactElement => <header>{children}</header>;

export default Header;
